<template>
  <div>
    <div class="card card-custom">
      <div class="card-header">
        <h3 class="card-title">Country Detail</h3>
      </div>

      <div class="card-body">
        <div class="row">

          <!-- Country Name -->
          <div class="col-md-6">
            <label>Country Name</label>
            <input type="text" v-model="form.C_NAME" class="form-control" />
          </div>

          <!-- Active -->
          <div class="col-md-6">
            <label>Active</label><br>
            <input type="checkbox" v-model="form.C_ISACTIVE" true-value="1" false-value="0" />
          </div>

        </div>

        <!-- Buttons -->
        <div class="mt-4">
          <a class="btn btn-primary" href="../UIC/CountryList">Back to List</a>
          <button class="btn btn-success float-right mr-1" @click="save">Save</button>

        </div>

      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      id: 0,
      form: {
        C_CODE: 0,
        C_NAME: "",
        C_ISACTIVE: "1"
      }
    };
  },

    created() {
      const params = new URLSearchParams(window.location.search);
      this.id = params.get("id");

      if (this.id) {
        this.loadData();
      }
    },
  methods: {
    loadData() {
      axios.get(`/api/UICApi/getCountryById?id=${this.id}`)
        .then(res => {
          if (res.data.status) {
            this.form = res.data.data;
          } else {
            toastr.error(res.data.msg);
          }
        });
    },

    save() {
      axios.post("/api/UICApi/saveCountry", this.form)
        .then(res => {
          if (res.data.status) {
            toastr.success("Saved Successfully");
            this.back();
          } else {
            toastr.error(res.data.msg);
          }
        });
    },

    back() {
      window.location.href = "/UIC/CountryList";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ims/Country.vue